import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import classes from '../GridTable.module.css';
export const Cell = ({ children, className, textAlign, verticalAlign, rowspan, colspan, 'data-tid': dataTid, }) => {
    const cellClasses = clsx(classes.cell, textAlign && classes[textAlign], verticalAlign && classes[verticalAlign], className);
    const cellStyle = {
        gridRow: rowspan && `span ${rowspan}`,
        gridColumn: colspan && `span ${colspan}`,
    };
    return (_jsx("div", { "data-tid": dataTid, className: cellClasses, style: cellStyle, children: verticalAlign ? _jsx("div", { className: classes.grow, children: children }) : children }));
};
